'use strict';

function objectHasKeys(obj) {
  return obj && Object.keys(obj).length > 0;
}

module.exports = objectHasKeys;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/functions/objectHasKeys.js
// module id = 50
// module chunks = 0